import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="countdown-timer"
export default class extends Controller {
  static targets = ["days", "hours", "minutes"];
  static values = {
    targetDate: String
  };

  connect() {
    this.targetDate = new Date(this.targetDateValue);
    this.startTimer();
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startTimer() {
    this.updateDisplay();
    this.timer = setInterval(() => {
      this.updateDisplay();
    }, 60000); // Update every minute
  }

  updateDisplay() {
    const now = new Date();
    const timeLeft = this.targetDate - now;

    if (timeLeft <= 0) {
      clearInterval(this.timer);
      this.showExpired();
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

    if (this.hasDaysTarget) {
      this.daysTarget.textContent = days;
    }
    if (this.hasHoursTarget) {
      this.hoursTarget.textContent = hours;
    }
    if (this.hasMinutesTarget) {
      this.minutesTarget.textContent = minutes;
    }
  }

  showExpired() {
    if (this.hasDaysTarget) {
      this.daysTarget.textContent = "0";
    }
    if (this.hasHoursTarget) {
      this.hoursTarget.textContent = "0";
    }
    if (this.hasMinutesTarget) {
      this.minutesTarget.textContent = "0";
    }
  }
}